// Danh sách các hạng mục khám cận lâm sàng với tên cột đúng từ database
export const examCategories = [
  { name: 'Siêu âm bụng', morning: 'sieu am bung sang', afternoon: 'sieu am bung chieu' },
  { name: 'Siêu âm vú', morning: 'sieu am vu sang', afternoon: 'sieu am vu chieu' },
  { name: 'Siêu âm giáp', morning: 'sieu am giap sang', afternoon: 'sieu am giap chieu' },
  { name: 'Siêu âm tim', morning: 'sieu am tim sang', afternoon: 'sieu am tim chieu' },
  { name: 'SA động mạch cảnh', morning: 'sieu am dong mach canh sang', afternoon: 'sieu am dong mach canh chieu' },
  { name: 'SA đàn hồi mô gan', morning: 'sieu am dan hoi mo gan sang', afternoon: 'sieu am dan hoi mo gan chieu' },
  { name: 'SA đầu dò âm đạo', morning: 'sieu am dau do am dao sang', afternoon: 'sieu am dau do am dao chieu' },
  { name: 'SA mạch máu chi dưới', morning: 'sieu am mach mau chi duoi sang', afternoon: 'sieu am mach mau chi duoi chieu' },
  { name: 'X-quang', morning: 'x quang sang', afternoon: 'x quang chieu' },
  { name: 'Điện tâm đồ', morning: 'dien tam do sang', afternoon: 'dien tam do chieu' },
  { name: 'Khám phụ khoa', morning: 'kham phu khoa sang', afternoon: 'kham phu khoa chieu' },
  { name: 'Đo loãng xương', morning: 'do loang xuong sang', afternoon: 'do loang xuong chieu' },
  { name: 'Điện não đồ', morning: 'dien nao do sang', afternoon: 'dien nao do chieu' },
  { name: 'Đo chỉ số ABI', morning: 'do chi so abi sang', afternoon: 'do chi so abi chieu' },
  { name: 'Đo chức năng hô hấp', morning: 'do chuc nang ho hap sang', afternoon: 'do chuc nang ho hap chieu' }
]
